export const AR_ACCOUNT_PATH = `/financial/ar-account`;
export const AR_ACCOUNT_CONFIRMATIONS_PATH = `${AR_ACCOUNT_PATH}/%d/confirmations`;
export const AR_ACCOUNT_CONFIRMATIONS_INVOICED_PATH = `${AR_ACCOUNT_PATH}/%d/invoices`;
export const PRINT_INVOICE_PATH = `financial/invoices/print`;
export const AR_ACCOUNT_INVOICE_PREVIEW_PATH = `${AR_ACCOUNT_PATH}/%d/preview-invoice`;
export const AR_ACCOUNT_INVOICE_PREVIEW_DETAILED_PATH = `${AR_ACCOUNT_PATH}/%d/preview-detailed-invoice`;
export const AR_ACCOUNT_CONFIRM_INVOICE_PATH = `${AR_ACCOUNT_PATH}/%d/confirm-invoice`;
export const AR_ACCOUNT_TRANSACTIONS_PATH = `${AR_ACCOUNT_PATH}/%d/transactions/%s/%d`;
